import React from 'react';

const SimpleIndex = () => {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-2">Test Page</h1>
        <p className="text-xl text-muted-foreground">This is a simple test to check if React is working</p>
        <div className="mt-8 p-4 bg-white border rounded-lg shadow">
          <p>If you can see this, React is working!</p>
        </div>
      </div>
    </div>
  );
};

export default SimpleIndex;
